import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileAppComponent } from './mobile-app/mobile-app.component';
import { MapMobileComponent } from './map-mobile/map-mobile.component';
import { FooterComponent } from './mobile-app/components/footer/footer.component';
import { TopbarComponent } from './mobile-app/components/topbar/topbar.component';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SidebarComponent } from './mobile-app/components/topbar/sidebar/sidebar.component';
import { SidebarModule } from 'primeng/sidebar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayersComponent } from './mobile-app/components/topbar/sidebar/layers/layers.component';
import { LegendsComponent } from './mobile-app/components/topbar/sidebar/legends/legends.component';
import { AccountComponent } from './mobile-app/components/topbar/sidebar/account/account.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { DividerModule } from 'primeng/divider';
import { HeadbandMobileComponent } from './map-mobile/headband-mobile/headband-mobile.component';
import { DepthDetailMobileComponent } from './map-mobile/headband-mobile/depth-detail-mobile/depth-detail-mobile.component';
import { ChartMobileComponent } from './map-mobile/headband-mobile/chart-mobile/chart-mobile.component';
import { ModeleModalMobileComponent } from './map-mobile/headband-mobile/modele-modal-mobile/modele-modal-mobile.component';
import { MapSensorsMobileComponent } from './map-mobile/headband-mobile/modele-modal-mobile/map-sensors-mobile/map-sensors-mobile.component';
import { GraphRealtimeMobileComponent } from './map-mobile/headband-mobile/modele-modal-mobile/graph-realtime-mobile/graph-realtime-mobile.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { GraphForecastMobileComponent } from './map-mobile/headband-mobile/modele-modal-mobile/graph-forecast-mobile/graph-forecast-mobile.component';
import { DropdownModule } from 'primeng/dropdown';
import { ListboxModule } from 'primeng/listbox';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeApp(translate: TranslateService) {
  return () => {
    return new Promise<void>((resolve) => {
      translate.setDefaultLang('fr');  // Définit la langue par défaut
      translate.use('fr').subscribe(() => {
        resolve();
      }, (error) => {
        console.error('Erreur lors du chargement des traductions :', error);
        resolve();  // Résoudre même en cas d'erreur pour ne pas bloquer l'application
      });
    });
  };
}

@NgModule({
  declarations: [
    MobileAppComponent,
    MapMobileComponent,
    FooterComponent,
    TopbarComponent,
    SidebarComponent,
    LayersComponent,
    LegendsComponent,
    AccountComponent,
    HeadbandMobileComponent,
    DepthDetailMobileComponent,
    ChartMobileComponent,
    ModeleModalMobileComponent,
    MapSensorsMobileComponent,
    GraphRealtimeMobileComponent,
    GraphForecastMobileComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CalendarModule,
    FormsModule,
    ButtonModule,
    SidebarModule,
    AutoCompleteModule,
    CheckboxModule,
    FontAwesomeModule,
    DividerModule,
    OverlayPanelModule,
    DropdownModule,
    ListboxModule
  ]
})
export class MobileModule { }
